import React, {Component, Fragment} from "react";
import {Calendar as BigCalendar, momentLocalizer} from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {displayMilHoursMinutesFromTime, forceUTCTimeZone, makeDate} from "../../util/datehelpers";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import EventTaskEditor from "./EventTaskEditor";
import {Button} from "reactstrap";
import {EventClient} from "../../util/eventClient";
import {deleteData} from "../../api/doLogin";
import moment from "moment";

let localizer = momentLocalizer(moment)

export default class TasksTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenTask: null, // null,
      showAddTaskEntry: false,
    }
  }

  removeTask(task) {
    const self = this;
    if (confirm(`Are you sure you want to remove the task ${task.title}?`)) {
      deleteData(`events/${this.props.eventId}/tasks/${task.id}`, {})
        .then((data) => {
          if (data.status === "Success") {
            this.setState({showAddTaskEntry: false, chosenTask: null}, () => {
              self.props.onUpdate && self.props.onUpdate(self.props.tasks.filter((ta) => ta.id !== task.id));
            });
          }
        })
        .catch(() => {
          console.error(error);
        });
    }
  }

  render() {
    let self = this;
    const eventStart = function (event) {
      return forceUTCTimeZone(makeDate(event.start));
    };
    const eventEnd = function (event) {
      return forceUTCTimeZone(makeDate(event.start).addHours(.5));
    };
    const titleAccessor = function (event) {
      return (Number(event.allDay) === 0 ? displayMilHoursMinutesFromTime(eventStart(event)) + " " : "") + event.title + ` (${event.status}%)`;
    };
    const agendaTitleAccessor = function (event) {
      return <div style={{cursor: "pointer", ...self.eventStyleGetter(event).style}}
                  title={titleAccessor(event)}
                  onClick={() => self.setState({chosenTask: event})}>{titleAccessor(event)}</div>;
    };
    const tasks = this.props.tasks.map((task) => {
      return {
        ...task,
        start: task.dueon,
      }
    })
    const min = (date)=>{
      const dated = new Date();
      return moment(dated).add(1, "day").toDate();
    }
    return (<div>
        <div style={{textAlign: "right", marginBottom: 2}}>
          <Button onClick={() => this.setState({showAddTaskEntry: true})}>Add</Button>
        </div>
        <BigCalendar views={['agenda', 'month', 'week', 'day']}
                     events={tasks}
                     step={60}
                     popup
                     localizer={localizer}
                     defaultDate={makeDate(this.props.start)}
                     defaultView='agenda'
                     toolbar={true}
                     selectable={true}
                     eventPropGetter={this.eventStyleGetter}
                     onSelectEvent={(event) => this.setState({chosenTask: event})}
                     startAccessor={eventStart}
                     endAccessor={eventEnd}
                     titleAccessor={agendaTitleAccessor}
                     onClick={console.log}
                     onEventResize={console.log}
                     draggableAccessor={event => true}
                     onSelectSlot={(selection) => console.log(selection)}
                     style={{height: '30em'}}
        />
        {(this.state.showAddTaskEntry || !!this.state.chosenTask) && (
          <MakeDialog isOpen={true}
                      size={"modal-lg"}
                      header={`Task`}
                      footer={<Fragment>
                        <Button color="primary"
                                onClick={() => EventClient.emit("TASK_ENTRY_SAVE", {})}>Save</Button>
                        {!!this.state.chosenTask && (
                          <Button color="danger"
                                  onClick={() => this.removeTask(this.state.chosenTask)}>Delete</Button>
                        )}
                        <Button color="secondary"
                                onClick={() => this.setState({
                                  showAddTaskEntry: false,
                                  chosenTask: null
                                })}>Close</Button>
                      </Fragment>}
          >
            <EventTaskEditor task={this.state.chosenTask}
                             eventId={this.props.eventId}
                             users={this.props.users}
                             saveEvent={"TASK_ENTRY_SAVE"}
                             eventName={"EventTaskEditor"}
                             onClose={() => this.setState({showAddTaskEntry: false, chosenTask: null})}
                             onSave={(task) => {
                               const tempTasks = [...this.props.tasks];
                               const taskIndex = tempTasks.findIndex((ta) => ta.id === task.id);
                               if (taskIndex > -1) {
                                 tempTasks[taskIndex] = task;
                               } else {
                                 tempTasks.push(task);
                               }
                               this.setState({showAddTaskEntry: false, chosenTask: null}, () => {
                                 this.props.onUpdate && this.props.onUpdate(tempTasks);
                               })
                             }}
            />
          </MakeDialog>
        )}

      </div>
    )
  }

  eventStyleGetter(event, start, end, isSelected) {
    let eventColor = "";
    let color = "";

    if (event.status < 0) {

    } else if (event.status < 50) {
      eventColor = "#f37676";
      color = "";
    } else if (event.status < 75) {
      eventColor = "#efb050";
      color = "#000000";
    } else if (event.status < 100) {
      eventColor = "#f8f8b1";
      color = "#000000";
    } else {
      eventColor = "#a7e8bd";
      color = "#000000";
    }
    var style = {
      backgroundColor: eventColor,
      color: color,
      fontSize: 10,
    };
    return {
      style: style
    };
  }
}


// WEBPACK FOOTER //
// ./src/containers/Events/TasksTab.js